export default __webpack_public_path__ + "static/media/check-white.77009b65.svg";